import http from './HttpService';

export function searchOrganisation(term) {
    return http.get(`api/organisations?term=${term}`);
}

export function searchFairsByPNumber(pNumber) {
    return http.get(`api/organisations/fairs?pNumber=${pNumber}`);
}